// extracted by mini-css-extract-plugin
module.exports = {"label":"AssessmentExperienceLabel_label__2L9g8"};